export default __webpack_public_path__ + "static/media/catReading.9cf65a12.svg";